import type { Transaction } from '@/modules/projects'
import { MemberRow } from './MemberRow'

interface MembersPaneProps {
  members: Transaction[]
  fileNameFor: (statementId: number) => string
  activeMemberId: number
  onSelect: (member: Transaction) => void
  onDelete: (member: Transaction) => void
}

export const MembersPane = ({
  members,
  fileNameFor,
  activeMemberId,
  onSelect,
  onDelete,
}: MembersPaneProps) => (
  <div className="space-y-3">
    <p className="text-xs leading-relaxed text-muted-foreground">
      Pick a row to see it on the statement. Delete the ones that really are
      copies, or mark the whole group as not duplicates.
    </p>
    <ul className="space-y-2">
      {members.map((member) => (
        <MemberRow
          key={member.id}
          member={member}
          fileName={fileNameFor(member.statementId)}
          isSelected={member.id === activeMemberId}
          onSelect={() => onSelect(member)}
          onDelete={() => onDelete(member)}
        />
      ))}
    </ul>
  </div>
)
